<template>
  <modal
    name="session-details"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="830"
    height="auto"
    @before-open="getData"
  >
    <div class="modalWrapper">
      <div class="content__box mb-4">
        <!-- Session details -->
        <div class="content__box__body">
          <div class="top__filter align-items-center mb-1">
            <ul class="top__filter__ul">
              <li class="cursor-default txt--semi-bold">
                Session Details
                <span class="txt--xs">(#{{ session.booking_no }})</span>
              </li>
              <li
                class="cursor-default txt--semi-bold"
                v-if="session.start_less_session"
              >
                (Start Less Session)
              </li>
            </ul>
            <ul class="top__filter__ul" v-if="session.deleted_at">
              <li class="cursor-default txt--red active">
                  Deleted At - {{dateFormat(session.deleted_at)}}</li>
            </ul>
            <ul v-else class="top__filter__ul">
              <!-- <li class="cursor-default">Past</li> -->
              <li
                class="cursor-default active"
                v-if="!session.booking_cancelled"
              >
                {{ session_type == 2 ? "Past" : "Active" }}
              </li>
              <li class="cursor-default active" v-else>Cancelled</li>
              <li
                class="cursor-pointer"
                v-if="hasAccess('session_access_write') && !session.deleted_at"
                @click="deleteSession(session.booking_id)"
              >
                Delete
              </li>
              <li
                class="cursor-pointer"
                v-if="hasAccess('session_access_write') && !session.deleted_at && !session.payment_status"
                @click="clearPendingPayment(session.booking_id)"
              >
                Clear Charge
              </li>
              <li
                class="cursor-pointer"
                v-if="hasAccess('session_access_write') && !session.deleted_at && !session.payment_status"
                @click="generatePaymentLink(session.booking_id)"
              >
                Collect Payment
              </li>
              <li
                class="cursor-pointer"
                v-if="hasAccess('session_access_write') && !session.deleted_at && session_type == 2"
                @click="restartSession(session.booking_id)"
              >
                Restart
              </li>
              <li
                class="cursor-pointer opacity--1"
                v-if="hasAccess('session_access_write') && !session.refunded_amount && session.payment_made"
                @click="refundSessionAmount(session.booking_id)"
              >
                <span class="txt--xs txt badge badge-pill ml-2 badge-success">Refund</span>
              </li>
              <li
                class="cursor-pointer opacity--1"
                v-if="hasAccess('session_access_write')"
                @click="syncSessionDetails(session.booking_id)"
              >
                <span class="txt--xs txt badge badge-pill ml-2 badge-success">Sync</span>
              </li>
            </ul>
          </div>
          <div class="form-row">
            <div class="col-sm-auto">
              <div class="sessionDataTxt">
                <p class="txt--fsxs opacity--50">Start</p>
                <p class="txt--fsxs ml-2" v-if="!session.start_less_session" v-tooltip="timezone">
                  {{ dateFormat(session.booking_start_date) }}
                </p>
              </div>
              <div class="sessionDataTxt">
                <p class="txt--fsxs opacity--50">End</p>
                <!-- To close active session -->
                <p class="txt--fsxs ml-2" v-if="session_type == 2" v-tooltip="timezone">
                  {{ dateFormat(session.booking_end_date) }}
                </p>
                <p v-else-if="session.deleted_at!=''" class="txt--fsxs cursor-default ml-2">
                  N/A
                </p>
                <p
                v-else-if="!session.booking_cancelled && hasAccess('session_access_write')"
                  class="txt--fsxs txt--primary cursor-pointer ml-2"
                  @click="endBook()"
                >
                  Manually End Session
                </p>
                <p
                v-else-if="!session.booking_cancelled"
                  class="txt--fsxs txt--primary ml-2"
                >
                  Ongoing Session
                </p>
                <!-- <p
                  class="txt--fsxs txt--primary cursor-pointer"
                  @click="endBook()"
                  v-else-if="!session.booking_cancelled"
                >
                  Manually End Session
                </p> -->
                <p class="txt--fsxs ml-2" v-else>N/A</p>
              </div>
              <div class="sessionDataTxt" v-if="session.rating !=''">
                <p class="txt--fsxs opacity--50">Customer's Review</p>
                <div class="review__ratings ml-2">
                  <stars-rating :config="modifyUserRating(session.rating)"></stars-rating>
                </div>
              </div>
            </div>
            <div class="col-sm-auto">
              <div class="sessionDataTxt">
                <p
                  class="
                  txt--fsxs opacity--50
                  "
                >
                  Location
                </p>
                <p class="txt--fsxs ml-2">
                  {{
                    Object.keys(session).length > 0
                      ? session.property_name != ""
                        ? session.property_name
                        : session.location.address
                      : "N/A"
                  }}
                </p>
              </div>
              <div class="sessionDataTxt">
                <p
                  class="
                   txt--fsxs opacity--50
                  "
                >
                  Duration
                </p>
                <p class="txt--fsxs text-truncate ml-2">
                  {{
                    !session.start_less_session && !session.booking_cancelled
                      ? session.stay_duration
                      : "N/A"
                  }}
                </p>
              </div>
              <div class="sessionDataTxt" style="align-items:baseline !important"  v-if="session.comment !=''">
                <p class="txt--fsxs opacity--50">Customer's Comment</p>
                <p class="txt--fsxs ml-2" style="max-width:360px;">"{{session.comment}}"</p>
              </div>
            </div>
            <div class="col-sm-auto">
              <div
                class="sessionAmnt"
                v-if="
                  session_type == 2 &&
                  session.customer_type != 2
                "
              >
                <div class="sessionDataTxt">
                  <p
                    class="
                      txt--fsxs opacity--50
                    "
                  >
                    Amount
                  </p>
                  <p class="txt--fsxs ml-2">
                    ${{
                      session.price_breakdown
                        ? session.price_breakdown.payable_amount
                        : 0
                    }}
                  </p>
                </div>
                <!-- <div class="sessionDataTxt">
                  <p
                    class="
                      txt--fsxs
                      sessionDataTxt__left sessionDataTxt__left--sessionEnd
                      txt--primary
                      cursor-pointer
                    "
                  >
                    Validate
                  </p>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- OLD VALIDATION -->
      <!-- <div class="content__box p-4 mb-4" v-if="session_type==1">
        <div class="row">
          <div class="col-sm-6 mb-3 mb-md-0">
            <model-list-select
              :list="validationList"
              v-model="choosedValidation"
              option-value="id"
              option-text="name"
              placeholder="Select validation"
              class="custom-vue-select"
            >
            </model-list-select>
          </div>
          <div class="col-sm-6">
             <ButtonWithSpinner
                class="button button--primary button--sm"
                :disabled="create_button.disabled"
                :loading="create_button.loading"
                :success="create_button.success"
                @click="saveValidation"
                >
                {{saveButtonText}}</ButtonWithSpinner
              >
          </div>
        </div>
      </div> -->
      
      <!-- Price Distribution -->
      <div class="content__box mb-4" v-if="session_type == 2 && session.price_breakdown && Object.keys(session.price_breakdown).length>0">
        <!-- Session details -->
        <div class="content__box__body">
          <div class="top__filter align-items-center mb-1">
            <ul class="top__filter__ul">
              <li class="cursor-default txt--semi-bold">
                Price Distribution
              </li>
            </ul>
            <ul class="top__filter__ul">
              <li class="cursor-default txt--semi-bold opacity--1">
                <a class="txt--primary" v-if="session.receipt_url && session.receipt_url.length" target="_blank" :href="session.receipt_url">View Receipt</a>
              </li>
            </ul>
          </div>
          <div class="form-row">
            <div class="col-sm-3">
              <div class="sessionDataTxt">
                <p class="txt--fsxs opacity--50">Subtotal</p>
                <p class="txt--fsxs ml-2">
                  ${{ session.price_breakdown.total_price }}
                </p>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="sessionDataTxt">
                <p class="txt--fsxs opacity--50">Parking Tax</p>
                <!-- To close active session -->
                <p class="txt--fsxs ml-2" >
                  ${{ session.price_breakdown.parking_tax }}
                </p>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="sessionDataTxt">
                <p class="sessionDataTxt__left--sessionEnd txt--fsxs opacity--50">
                  Discount
                </p>
                <p class="txt--fsxs">
                  ${{ session.price_breakdown.discount}}
                </p>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="sessionDataTxt">
                <p class="sessionDataTxt__left--sessionEnd txt--fsxs opacity--50">
                  Amount
                </p>
                <p class="txt--fsxs text-truncate">
                  ${{ session.price_breakdown ? session.price_breakdown.payable_amount : 0}} 
                  <span v-if="session.payment_status == false" class="text-danger txt--ss font-weight-bold"> (Pending)</span>
                  <span v-if="session.refunded_amount == true" class="text-warning txt--ss font-weight-bold"> (Refunded)</span>
                  <span v-if="session.refunded_amount != true && session.payment_made == true" class="text-success txt--ss font-weight-bold"> (Paid)</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content__box mb-4" v-if="session.validation && session.validation.id">
        <!-- Validation details -->
        <div class="content__box__body">
          <div class="top__filter align-items-center mb-1">
            <ul class="top__filter__ul">
              <li class="cursor-default txt--semi-bold">
                Validation
              </li>
            </ul>
          </div>
          <div class="form-row">
            <div class="col-sm-12 mt-2" v-if="session.validation && session.validation.id">
              <p class="txt--xs">
                <b>Validation Applied:</b> {{ session.validation.name || session.validation.id }} 
              </p>
              <p class="txt--xs" v-if="session.validation.applied_by && session.validation.applied_by.first_name && session.validation.applied_by.last_name">
                <b>Validator Name:</b> {{ [session.validation.applied_by.first_name, session.validation.applied_by.last_name].filter(x => !!x).join(' ') }}
              </p>
              <p class="txt--xs" v-if="session.validation.applied_by && session.validation.applied_by.email">
                <b>Validator Email:</b> {{ session.validation.applied_by.email || '' }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- Entry and Exit Gate Images -->
      <div class="content__box mb-4">
        <div class="content__box__body">
          <div class="form-row">
            <div class="col-sm-6">
              <p
                class="
                  txt--ss txt--off-white
                  mb-2
                  d-flex
                  justify-content-center
                "
              >
                Entry
              </p>
              <div class="form-row d-flex justify-content-center">
                <div
                  class="col-9"
                  v-if="
                    !entry_image_fetching &&
                    session.entry_image_name != '' &&
                    session.entry_image != '' &&
                    !session.start_less_session
                  "
                >
                  <!-- <img
                    src="@/assets/images/live-image1.png"
                    class="w-100"
                    alt="Entry image"
                  /> -->
                  <img
                    :src="session.entry_image"
                    alt="Entry Image"
                    class="w-100"
                  />
                </div>
                <!-- <div class="col-6 mt-3 mt-sm-0">
                  <img
                    src="@/assets/images/live-image2.png"
                    class="w-100"
                    alt="Entry image"
                  />
                </div> -->
              </div>
            </div>
            <div class="col-sm-6">
              <p
                class="
                  txt--ss txt--off-white
                  mb-2
                  d-flex
                  justify-content-center
                "
              >
                Exit
              </p>
              <div class="form-row d-flex justify-content-center">
                <div
                  class="col-9"
                  v-if="
                    !exit_image_fetching &&
                    session.exit_image_name != '' &&
                    session.exit_image != '' &&
                    session_type == 2
                  "
                >
                  <!-- <img
                    src="@/assets/images/live-image3.png"
                    class="w-100"
                    alt="Exit image"
                  /> -->
                  <img
                    :src="session.exit_image"
                    alt="Exit Image"
                    class="w-100"
                  />
                </div>
                <!-- <div class="col-6 mt-3 mt-sm-0">
                  <img
                    src="@/assets/images/live-image4.png"
                    class="w-100"
                    alt="Exit image"
                  />
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Customer Details -->
      <div class="content__box mb-4">
        <div class="content__box__header">
          <div class="top__filter">
            <ul class="top__filter__ul">
              <li
                class="cursor-default"
                v-if="session.booking_type == 'anonymous'"
              >
                <span class="txt--semi-bold"> Anonymous Customer </span>
              </li>
              <li
                class="cursor-default"
                v-else-if="session.booking_type == 'transient'"
              >
                <span class="txt--semi-bold">
                  Transient Customer ({{
                    session.user ? session.user.first_name : "N/A"
                  }})
                </span>
              </li>
              <li class="cursor-default" v-else>
                <span class="txt--semi-bold"
                  >Permit Customer ({{
                    session.user ? session.user.first_name : "N/A"
                  }})</span
                >
              </li>
            </ul>
            <ul
              class="top__filter__ul"
              v-if="session.booking_type != 'anonymous'"
            >
              <li class="cursor-pointer" @click="showCustomer()">
                {{ show_cust ? "Hide" : "View" }} Customer
              </li>
            </ul>
          </div>
          <h2 class="txt--fslg pb-1" v-if="show_cust">
            {{
              session.user
                ? session.user.first_name + " " + session.user.last_name
                : ""
            }}
          </h2>
          <p class="txt--fsxs pb-1" v-if="show_cust">
            {{ session.user ? session.user.email : "" }}
          </p>
          <p class="txt--fsxs" v-if="show_cust">
            {{ session.user ? session.user.phone_number : "" }}
          </p>
        </div>
      </div>

       <!-- Permit Details -->
      <div class="content__box mb-4"  v-if="session.booking_type == 'monthly' || session.booking_type == 'permit'">
        <div class="content__box__header">
          <div class="form-row">
            <div class="col-sm-auto">
              <div class="sessionDataTxt">
                <p class="txt--fsxs opacity--50">Permit Name</p>
                <p class="txt--fsxs ml-2">{{ session.permit_name || session.permit_id ? (session.permit_name || session.permit_id) : "N/A" }}</p>
              </div>
              <div class="sessionDataTxt mb-0">
                <p class="txt--fsxs opacity--50">Permit Type</p>
                <p class="txt--fsxs text-truncate ml-2">{{ session.permit_type ? session.permit_type : "N/A" }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Details -->
      <div class="content__box mb-4" v-if="session_type == 2">
        <div class="content__box__header">
          <div class="top__filter">
            <ul class="top__filter__ul">
              <li class="cursor-default">Payment</li>
            </ul>
          </div>
          <div class="d-flex flex-wrap">
            <div
              class="payment__card"
              v-if="session.card_details && session.card_details.brand != ''"
            >
              <img
                :src="getCreditcardLogo(session.card_details.brand)"
                alt="CardImage"
              />
            </div>
            <div class="payment__card" v-else>
              <img
                src="@/assets/images/DebitCardImage/credit-card.png"
                alt="cardImage"
              />
            </div>
            <div class="modal__payment__text pl-3">
              <div class="sessions_start_duration text-right mr-3">
                <p class="txt--fsxs opacity--50 text-truncate">Type</p>
                <p class="txt--fsxs opacity--50 pt-2 text-truncate">Last 4</p>
              </div>
              <div class="activity__msg txt--semi-bold">
                <p class="txt--fsxs text-truncate">
                  {{
                    session.card_details && session.card_details.brand != ""
                      ? session.card_details.brand
                      : "N/A"
                  }}
                </p>
                <p class="txt--fsxs pt-2 text-truncate">
                  {{
                    session.card_details &&
                    session.card_details.last4_digit != ""
                      ? session.card_details.last4_digit
                      : "N/A"
                  }}
                </p>
              </div>
            </div>
            <div class="modal__payment__text pl-5">
              <div class="sessions_start_duration text-right mr-3">
                <p class="txt--fsxs opacity--50 text-truncate">Exp</p>
              </div>
              <div class="activity__msg txt--semi-bold">
                <p class="txt--fsxs text-truncate">
                  {{
                    session.card_details && session.card_details.exp_month != ""
                      ? session.card_details.exp_month +
                        "/" +
                        session.card_details.exp_year
                      : "N/A"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Vehicle Details -->
      <div class="content__box">
        <div class="content__box__body">
          <div class="top__filter align-items-center mb-1">
            <ul class="top__filter__ul">
              <li class="cursor-default">Vehicle</li>
            </ul>
            <ul class="top__filter__ul">
              <li
                class="cursor-pointer"
                v-if="
                  !edit_mode &&
                  !session.deleted_at &&
                  !session.booking_cancelled &&
                  hasAccess('session_access_write')
                "
                @click="showEditVehicle"
              >
                Edit
              </li>
            </ul>
          </div>

          <div class="d-flex flex-wrap">
            <div class="activity__indicator">
              <div
                class="sessions_number_box cursor_class text-center"
                v-if="
                  session.vehicle_details &&
                  session.vehicle_details.license_id != ''
                "
              >
                <div class="txt--xs txt--red txt--bold images_state">
                  {{
                    session.vehicle_details.state_full_name
                      ? session.vehicle_details.state_full_name
                      : session.vehicle_details.country
                  }}
                </div>
                <p class="txt--fsxs text-truncate txt--bold pt-1">
                  {{ session.vehicle_details.license_id }}
                </p>
              </div>
              <div v-else class="sessions_number_box_long text-center">
                <p class="txt--fsxs text-truncate txt--bold pt-1">
                  {{
                    session.vehicle_details
                      ? session.vehicle_details.vin_id
                      : "N/A"
                  }}
                </p>
              </div>
            </div>
            <div class="modal__payment__text px-3">
              <div class="sessions_start_duration text-right mr-3">
                <p class="txt--fsxs opacity--50">Year</p>
                <p class="txt--fsxs opacity--50 pt-2">Make</p>
              </div>
              <div class="activity__msg txt--semi-bold">
                <p class="txt--fsxs text-truncate">
                  {{
                    session.vehicle_details &&
                    session.vehicle_details.model_year != ""
                      ? session.vehicle_details.model_year
                      : "N/A"
                  }}
                </p>
                <p class="txt--fsxs pt-2 text-truncate">
                  {{
                    session.vehicle_details &&
                    session.vehicle_details.make != ""
                      ? session.vehicle_details.make
                      : "N/A"
                  }}
                </p>
              </div>
            </div>
            <div class="modal__payment__text">
              <div class="sessions_start_duration text-right mr-3">
                <p class="txt--fsxs opacity--50">Model</p>
                <p class="txt--fsxs opacity--50 pt-2">Color</p>
              </div>
              <div class="activity__msg txt--semi-bold">
                <p class="txt--fsxs text-truncate">
                  {{
                    session.vehicle_details &&
                    session.vehicle_details.model != ""
                      ? session.vehicle_details.model
                      : "N/A"
                  }}
                </p>
                <p class="txt--fsxs pt-2 text-truncate">
                  {{
                    session.vehicle_details &&
                    session.vehicle_details.color != ""
                      ? session.vehicle_details.color
                      : "N/A"
                  }}
                </p>
              </div>
              <div class="modal__payment__text px-3">
              <div class="sessions_start_duration text-right mr-3">
                <p class="txt--fsxs opacity--50">Fuel Type</p>
              </div>
              <div class="activity__msg txt--semi-bold">
                <p class="txt--fsxs text-truncate">
                  {{
                    session.vehicle_details &&
                    session.vehicle_details.fuel_type != ""
                      ? fuel_type_list.find(item => item.value === session.vehicle_details.fuel_type)?.label
                      : "N/A"
                  }}
                </p>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      <!-- textarea for comment -->
      <div class="content__box mt-3 p-3 position-relative overflow-auto">
        <div v-if="comment_loader == true">
            <div class="d-flex justify-content-center">
              <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
        </div>
        <div v-for="(comment, index) in comments" :key="index">
          <span title="March 10,2022 16:58:24" style="color: #f5a621; font-size: 12px; line-height: 25px;" class="font-weight-bold">
            {{ comment.commented_by }}
          </span>
          <span style="color: rgba(255,255,255,0.5); font-size: 12px; line-height: 25px;">
            {{ comment.comment }}
          </span>
          <!-- <p style="color: rgba(255,255,255,0.5); font-size: 12px; line-height: 25px; border-bottom: 1px solid #444444;" class="font-weight-bold">
            {{ dateFormat(comment.comment_time) }}
            {{ comment.commented_by +' '+ comment.comment }}
          </p> -->
        </div>

        <form action="#" @submit.prevent="commentStore()">
          <div v-show="comment_section">
            <textarea name="" id="" style="width: 100%; padding: 8px; font-size: 14px; color: grey;" class="d-block my-4" v-model="comment_form.comment" ></textarea>
            <button 
              type="submit" 
              id="send-btn" 
              style="font-size: 12px; 
              outline: none; background: none; 
              border: none; color: white;
              background: var(--primaryColor);                     
              padding: 5px 10px;
              border-radius: 5px;"
            >
            {{submit_button == true ? 'Send': 'Close'}}</button>
          </div>
        </form>
        <button 
          v-if="hasAccess('session_access_read')"
          type="button"
          style="font-size: 12px; 
          outline: none; 
          background: none; 
          border: none; 
          color: white;
          background: var(--primaryColor);                     
          padding: 5px 10px;
          border-radius: 5px;"
          class="ml-auto"
          id="cmnt-btn" @click="showCommentArea()" :class="comment_section == true ? 'd-none' : 'd-block'" 
        >
          Add comment
        </button>
      </div>
      <div class="content__box mt-2" v-if="edit_mode">
        <div class="content__box__body">
          <div class="top__filter align-items-center mb-1">
            <ul class="top__filter__ul">
              <li class="cursor-default">Edit Vehicle</li>
            </ul>
            <ul class="top__filter__ul">
              <li class="cursor-pointer" @click="cancelEditMode">Cancel</li>
            </ul>
          </div>
          <div class="form-row">
            <div class="col-sm-6 d-none">
              <div class="form-group">
                <p class="txt--fsxs mb-3">
                  <span class="opacity--50"> Select </span>
                  <span class="text-white txt--semi-bold">License</span>
                </p>
                <!-- <model-list-select
                  :list="vehicle_list_filtered"
                  v-model="vehicle_form.vehicle_id"
                  option-value="vehicle_id"
                  :custom-text="customText"
                  placeholder="Select License"
                  class="custom-vue-select"
                  @searchchange="searchVehicle"
                >
                </model-list-select> -->
                <!-- <v-select
                  class="v-select-input"
                  label="license_id"
                  :searchable="true"
                  :options="vehicle_list_filtered"
                  :clearable="false"
                  v-model="vehicle_form.vehicle_id"
                  :reduce="(vehicle) => vehicle.vehicle_id"
                  placeholder="Select License"
                  @open="startObserv"
                  @close="stopObserv"
                  @search="searchVehicle"
                >
                  <template #list-footer>
                    <li
                      ref="load"
                      class="loader vs__dropdown-option"
                      v-show="load_more_vehicle"
                    >
                      Loading more options...
                    </li>
                  </template>
                </v-select> -->
              </div>
            </div>
            <div class="col-sm-12 mb-4 d-none">
              <p class="txt--ss d-flex justify-content-center">Or</p>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <p class="txt--fsxs mb-3">
                  <span class="opacity--50"> Enter </span>

                  <span class="text-white txt--semi-bold">New Plate</span>
                </p>
                <input
                  type="text"
                  placeholder="Enter Custom plate"
                  class="input__field"
                  v-model="vehicle_form.license"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <p class="txt--fsxs mb-3">
                  <span class="opacity--50"> Enter </span>

                  <span class="text-white txt--semi-bold">New VIN</span>
                </p>
                <input
                  type="text"
                  placeholder="Enter Custom plate"
                  class="input__field"
                  v-model="vehicle_form.vin"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <p class="txt--fsxs mb-3">
                  <span class="opacity--50"> Choose </span>
                  <span class="text-white txt--semi-bold">Country</span>
                </p>
                <model-list-select
                  :list="country_list"
                  v-model="vehicle_form.country_code"
                  option-value="country_code"
                  option-text="country_name"
                  placeholder="Select Country"
                  class="custom-vue-select"
                >
                </model-list-select>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <p class="txt--fsxs mb-3">
                  <span class="opacity--50"> Choose </span>
                  <span class="text-white txt--semi-bold">State</span>
                </p>
                <model-list-select
                  :list="state_list"
                  v-model="vehicle_form.state"
                  option-value="short_code"
                  option-text="full_name"
                  placeholder="Select State"
                  class="custom-vue-select"
                >
                </model-list-select>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <p class="txt--fsxs mb-3">
                  <span class="opacity--50"> Enter </span>

                  <span class="text-white txt--semi-bold">Make</span>
                </p>
                <input
                  type="text"
                  placeholder="Enter Make"
                  class="input__field"
                  v-model="vehicle_form.make"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <p class="txt--fsxs mb-3">
                  <span class="opacity--50"> Enter </span>

                  <span class="text-white txt--semi-bold">Model</span>
                </p>
                <input
                  type="text"
                  placeholder="Enter Model"
                  class="input__field"
                  v-model="vehicle_form.model"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <p class="txt--fsxs mb-3">
                  <span class="opacity--50"> Choose </span>
                  <span class="text-white txt--semi-bold">Fuel Type</span>
                </p>
                <model-list-select
                  :list="fuel_type_list"
                  v-model="vehicle_form.fuel_type"
                  option-value="value"
                  option-text="label"
                  placeholder="Select Fuel Type"
                  class="custom-vue-select"
                >
                </model-list-select>
              </div>
            </div>
          </div>
          <div
            class="
              pt-4
              d-flex
              justify-content-center
              align-items-center
              validate-box
              flex-warp
            "
          >
           <!--  <button
              class="button button--primary button--sm mr-3"
              @click="changeVehicle"
            >
              Submit
            </button> -->

            <ButtonWithSpinner
                  class="button button--primary button--sm mr-3 mb-2"
                  :disabled="buttonChngVehicle.disabled"
                  :loading="buttonChngVehicle.loading"
                  :success="buttonChngVehicle.success"
                  @click="changeVehicle"
                >
                  Submit
            </ButtonWithSpinner>
          </div>
        </div>
      </div>

      <div
        class="pt-4 d-flex justify-content-center align-items-center validate-box flex-warp"
        v-if="session_type == 1 && ['anonymous', 'transient'].includes(session.booking_type) && validationList.length>0"
      >
        <button
          class="button button-outline-primary mr-3 mb-2"
          @click="openValidationModal()"
        >
          Validate
        </button>
        <button class="button button--outline mb-2" @click="closeModal()">
          Cancel
        </button>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
      <PaymentLink />
    </div>
  </modal>
</template>

<script>
import { ModelListSelect } from "vue-search-select";
import ButtonWithSpinner from "@/components/Button";
import starRating from "@/components/StarRating";
import Vue from 'vue';
import { Datetime } from "vue-datetime";
import Toggle from "@/components/toggle";
import PaymentLink from "@/components/modals/PaymentLink";
export default {
  name: "sessionDetailsModal",
  components: {
    ModelListSelect,
    ButtonWithSpinner,
    PaymentLink,
    "stars-rating": starRating,
  },
  data() { 
    return {
      property_timezone: '',
      timezone: '',
      validationList: [],
      property_id:'',
      validationPage:1,
      choosedValidation: null,
      session: {},
      session_type: 1,
      entry_image_fetching: false,
      exit_image_fetching: false,
      show_cust: false,
      edit_mode: false,
      admin_access: false,
      comment_section:false,
      submit_button :false,
     // comment_data : [],
      // comment_message: '',
      vehicle_form: {
        license: "",
        country_code: "",
        state: "",
        vin: "",
        make: "",
        model: "",
        year: "",
        fuel_type: "",
        color: "",
        region_code: "",
        vehicle_id: "",
        property_id: "",
      },
      create_button: {
          disabled: false,
          loading: false,
          success: false,
      },
      buttonChngVehicle: {
        loading: false,
        success: false,
        disabled: false,
      },
      country_list: [],
      state_list: [],
      fuel_type_list: [],
      vehicle_list: [],
      vehicle_source: null,
      page: 1,
      load_more_vehicle: false,
      observer: null,
      vehicle_search: "",
      loading: false,
      saveButtonText:'Save',
      validation_apply_message:'',
      comment_form: {
        comment:      '',
        session_id:   null,
        commented_by: null,
      },
      comments: [],
      comment_loader: true,
      user_role:    '',
      access_list:  {},
      triggered_from: '',
    };
  },
  watch: {
    "vehicle_form.country_code": function (val) {
      if (val != "") {
        this.state = "";
        this.getStates();
      }
    },
    "comment_form.comment" : function (val){
      if(val.length > 0){
        this.submit_button = true;
        return ;
      }
      this.submit_button = false;
    }
  },
  computed: {
    vehicle_list_filtered: function () {
      if (this.vehicle_list.length == 0) return [];

      return this.vehicle_list.filter((val) => val.license_id != "");
    },
  },
  created() {
    this.user_role    = localStorage.getItem("role");
    this.access_list  = JSON.parse(localStorage.getItem("commercial_access_list")) || {};
    this.fetchFuelTypes();
  },
  mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll);
  },
  methods: {
    hasAccess(permission_name) {
        return this.admin_access
            || this.user_role === 'commercial'
            || this.user_role === 'operator' && !!this.access_list[permission_name];
    },
    generatePaymentLink(booking_id) {
      this.$modal.show("payment-link", {
        booking_id: booking_id,
      });
    },
    clearPendingPayment(booking_id) {
      this.$swal({
        title: "Clear Charge",
        text: "Are you sure you want to clear the charge?",
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.__clearPendingPayment(booking_id);
        }
      });
    },
    __clearPendingPayment(booking_id) {
      this.axios.post(window.hostname + "api/auth/clear-pending-session", {
        booking_id: booking_id,
      }).then((res) => {
        if (res.data.status) {
          this.$toasted.show(res.data.message, {
            className: "success-class",
            icon: "check-circle",
          });
          
          this.$modal.hide("session-details");
        }
      }).catch((error) => {
        console.error(error);
        
        this.$toasted.show("Unexpected error!", {
          icon: 'times-circle',
          className: 'error-class'
        });
      });
    },
    restartSession(booking_id) {
      this.$swal({
        title: "Restart Session",
        text: "Are you sure you want to restart the session?",
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.__restartSession(booking_id);
        }
      });
    },
    __restartSession(booking_id) {
      this.axios.post(window.hostname + "api/auth/restart-session", {
        booking_id: booking_id,
      }).then((res) => {
        if (res.data.status) {
          this.$toasted.show(res.data.message, {
            className: "success-class",
            icon: "check-circle",
          });
          
          this.$modal.hide("session-details");
        }
      }).catch((error) => {
        console.error(error);
        
        this.$toasted.show("Unexpected error!", {
          icon: 'times-circle',
          className: 'error-class'
        });
      });
    },
    commentStore(){
      // console.log(this.session.user.id);
      if(this.submit_button == false)
      {
        this.comment_section = false;
        return;
      }

      if(this.comment_form.comment.trim().length == 0)
      {
        this.$toasted.show("Please type a comment!",{
              icon: 'times-circle',
              className: 'error-class'
            });
        return;
      }

      var user_id = '';

      if(localStorage.getItem("admin_access") == null)
      {
        user_id = localStorage.getItem("user_id");
      }
      else
      {
        user_id = localStorage.getItem("admin_id");
      }

      if(this.comment_form.comment != '')
      {
        this.axios
          .post(window.hostname + "api/auth/add-session-comment", {
            comment:      this.comment_form.comment,
            session_id:   this.session.booking_id,
            device_type:  1,
            commented_by: user_id,
          })
          .then((res) => {
            if (res.data.status) 
            {
              this.$toasted.show(res.data.message, 
              {
                className:  "success-class",
                icon:       "check-circle",
              });
              this.comment_section      = false;
              this.comment_form.comment = '';
            }
            this.getSessionComment();
          })
          .catch((error) => {
            // console.log(error.response.data);
          });
      }
    },
    getSessionComment()
    {
      this.comments = [],
      this.comment_loader = true;
      this.axios
        .post(window.hostname + "api/auth/get-session-comment", {
          device_type: 1,
          booking_id: this.session.booking_id,
        })
        .then((res) => {
          this.comment_loader = false;
          if (res.data.status) {
              this.comments = res.data.data;
          }
        })
        .catch((error) => {
          //console.log(error.response.data.message);
        });
    },
    showCommentArea(){
      this.comment_section = true;
    },
    openValidationModal() {
      let html = `<div class="validate-modal txt--off-white">`;
      html+= `<p class="txt--ss font-weight-bold mb-2">Validate</p>`;
      html += `<select class="textInputField" name="validation_duration" id="validation_duration">`;
      //console.log(this.validationList);
      const self = this;

      html += `<option value=''>Select Validation</option>`;

      this.validationList.map((validation)=> {
        html+= `<option value="`+validation.id+`" `;
        if(this.choosedValidation == validation.id) {
          html+= `selected`;
        }
        html+= `> `+validation.name+`</option>`;
      });
      html += `</select>`;
      html += '</div>'
      this.$swal({
        html: html,
        customClass: {
          container: "validate-swal-container",
          confirmButton: "confirm-button-class",
          cancelButton: "cancel-button-class",
        },
        showCancelButton: true,
        preConfirm: () => {
          let selected_validation = document.getElementById("validation_duration").value;
          if(selected_validation== '') {
            self.$toasted.show("Please select a validation!",{
              icon: 'times-circle',
              className: 'error-class'
            });
            return false;
          }
        }
      }).then((result) => {
        if (result.isDismissed) {
          return false;
        }
        if(result.isConfirmed) {
          self.choosedValidation = document.getElementById("validation_duration").value;

          self.saveValidation();
        }
      });
    },
    closeModal() {
      this.$modal.hide("session-details");
      if(this.triggered_from == 'review'){
         this.triggered_from = '';
         this.$modal.show("review-modal");
      }
    },
    getValidationList(event){
         this.axios
            .post(window.hostname + "api/auth/validation/list", {
              device_type: 1,
              booking_id: this.session.booking_id,
              property_id: event.params.property_id,
              time_zone: this.$moment.tz.guess(),
              trigger: "Operator",
            })
            .then((res) => {
                if (res.data.status) {
                    this.validationList = res.data.data.validation_list;
                    this.validationPage = res.data.data.pagination.page;
                }
            })
            .catch((error) => {
              //console.log(error.response.data.message);
            });
    },
    saveValidation(){
      if (this.choosedValidation==null || this.choosedValidation==''){
        this.$toasted.show('Please Select Validation',{
          icon : 'times-circle',
          className: 'error-class'
        });
        return;
      }
      this.create_button.loading = true;
      this.create_button.disabled = true;
      this.create_button.success = false;
      
      this.axios
        .post(window.hostname + "api/auth/validation/apply", {
          device_type: 1,
          booking_id: this.session.booking_id,
          validation_id: this.choosedValidation,
          property_id: this.property_id,
          time_zone: this.$moment.tz.guess(),
          trigger: "Operator",
        })
        .then((res) => {
            if (res.data.status) {
              this.$toasted.show(res.data.message, {
                icon: "check-circle",
                className: "success-class",
              });
              this.create_button.disabled = false;
              this.create_button.success = true;
              this.create_button.loading = false;
              this.$emit("session_reload", {});

              this.session.validation = this.validationList.find(element => element.id == this.choosedValidation);
            }
            else{
              this.$toasted.show(res.data.message,{
                icon : 'times-circle',
                className: 'error-class'
              });
              this.create_button.disabled = false;
              this.create_button.success = false;
              this.create_button.loading = false;
            }
        })
        .catch((error) => {
          ////console.log(error.response.data.message);
          this.create_button.disabled = false;
          this.create_button.success = false;
          this.create_button.loading = false;
          this.$toasted.show(error.response.data.message,{
              icon : 'times-circle',
              className: 'error-class'
          });
        });
    },
    // Fetch Fuel Types from API
    fetchFuelTypes() {
      this.axios
        .post(window.hostname + 'api/auth/vehicle/fuel-types')
        .then((response) => {
          if (response.data.status) {
            this.fuel_type_list = Object.entries(response.data.data).map(([key, value]) => ({
              value: key,
              label: value
            }));
          } else {
            this.fuel_type_list = [];
          }
        })
        .catch((err) => {
          console.error('Error fetching fuel types:', err);
          this.fuel_type_list = [];
        });
    },
    getData(event) {
      if (event.params != undefined) {
        this.timezone = event.params.timezone;
        this.session = event.params.data;
        // Ensure receipt_url is always reactive in Vue 2 even if missing from payload.
        this.$set(this.session, "receipt_url", this.session.receipt_url || "");
        this.session.booking_no = event.params.data.booking_no;
        this.session.entry_image = "";
        this.session.exit_image = "";
        this.property_id = event.params.property_id;
        this.property_timezone = event.params.property_timezone;
        this.session_type = event.params.session_type;
        //console.log("event.params.triggered_from>>>"+ event.params.triggered_from);
        this.triggered_from = (event.params.triggered_from==null || event.params.triggered_from=='' ||  event.params.triggered_from=='undefined') ?'':event.params.triggered_from;
        
        this.saveButtonText = (event.params.validation_id==null || event.params.validation_id=='')?'Save':'Update';
        this.choosedValidation = (event.params.validation_id==null || event.params.validation_id=='')?null:event.params.validation_id;
        if (this.session.booking_end_date != "") {
          this.session_type = 2;
        } else {
          this.session_type = 1;
        }
        this.getValidationList(event);
        this.getEntryExitImages();
        this.getSessionComment();
        this.edit_mode = false;
      }

      if (
        localStorage.getItem("admin_access") &&
        localStorage.getItem("admin_access") == "true"
      ) {
        this.admin_access = true;
      }
      console.log(this.session);
    },
    dateFormat(value) {
      if (value) {
        //console.log(new Date(value));
        return this.$moment(new Date(value)).format("MMMM DD,YYYY HH:mm:ss");
      }
    },
    endBook() {
      let end_date = this.$moment(new Date()).utc().format();
      let isDatetimeVisible = false;
      let timezone = this.property_timezone;
      this.$swal({
        html:`
          <p class="txt--ss font-weight-bold txt--off-white">Are you sure you want to end this session?</p>
          <div id="datetime-end_date">
          </div>
        `,
        showCancelButton: true,
        onOpen: () => {
          Vue.component('datetime', Datetime);
          const SwalDatetime = new Vue({
            data: function() {
              return {
                isDatetimeVisible: isDatetimeVisible,
              };
            },
            methods: {
              toggleDatetime() {
                this.isDatetimeVisible = !this.isDatetimeVisible;
                isDatetimeVisible = this.isDatetimeVisible;

                this.$refs.toggle1.active = !this.isDatetimeVisible;
                this.$refs.toggle2.active = this.isDatetimeVisible;

              },
              handleDatetimeInput(newValue) {
                if (newValue) {
                  end_date = this.$moment(newValue).utc().format();
                }
              },
            },
            render: function (createElement) {
              return createElement('div',
              {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  width: "fit-content"
                },
              },
              [
                createElement(Toggle, {
                  ref: 'toggle1',
                  props: {
                    label: 'End at grace period',
                    checked: !this.isDatetimeVisible
                  },
                  on: {
                    'update:checked': this.toggleDatetime
                  }
                }),
                createElement('div',
                {
                  style: {
                    display: "flex",
                  }
                },
                [
                  createElement(Toggle, {
                    ref: 'toggle2',
                    props: {
                      label: 'End at custom time',
                      checked: this.isDatetimeVisible
                    },
                    on: {
                      'update:checked': this.toggleDatetime
                    }
                  }),
                  createElement('datetime', {
                    ref: 'datetime',
                    attrs: {
                      type: "datetime",
                      format: "yyyy-MM-dd hh:mm a",
                      "input-class": [
                        'hidden_input'
                      ],
                      "value-zone": timezone,
                      zone: timezone,
                    },
                    class: ["dateTime__picker"],
                    style: {
                      visibility: this.isDatetimeVisible ? "visible" : "hidden",
                    },
                    directives: [
                      {
                        name: 'tooltip',
                        value: timezone,
                        modifiers: {
                          placement: 'top'
                        }
                      }
                    ],
                    value: end_date,
                    on: {
                      input: this.handleDatetimeInput,
                    },
                  }),
                ]),
              ]);
            },
          }).$mount();

          document.getElementById('datetime-end_date').appendChild(SwalDatetime.$el);
          SwalDatetime.$refs.datetime.setValue({target: { value: end_date}});
        },

      }).then((result) => {
        if (result.isDismissed) {
          return false;
        }
        if (result.value) {
          this.axios
            .post(window.hostname + "api/auth/booking", {
              device_type: 1,
              mode: "make-payment",
              admin_confirm: 1,
              end_session: 1,
              booking_id: this.session.booking_id,
              time_zone: this.$moment.tz.guess(),
              trigger: "Operator",
              end_date: isDatetimeVisible ? end_date : null
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.$emit("session_removed", {
                  session: this.session,
                  response: res.data.data,
                });
                this.$modal.hide("session-details");
              } else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
              }
            })
            .catch((error) => {
              //console.log(error.response.data.message);
            });
          return;
        }
      });
    },
    getCreditcardLogo(card) {
      var image = require("@/assets/images/DebitCardImage/credit-card.png");
      try {
        image = require("@/assets/images/DebitCardImage/" + card + ".png");
      } catch (e) {
        image = require("@/assets/images/DebitCardImage/credit-card.png");
      }
      return image;
    },
    getEntryExitImages() {
      let entry_bucket_name_api = "";
      if (this.session.entry_bucket_name == "NEW") {
        entry_bucket_name_api =
          window.awsURLNew + this.session.entry_image_name;
      } else if (this.session.entry_bucket_name == "OLD") {
        entry_bucket_name_api = window.awsURL + this.session.entry_image_name;
      } else {
        entry_bucket_name_api = window.awsURL + this.session.entry_image_name;
      }

      if (this.session.entry_image_name != "") {
        this.entry_image_fetching = true;
        fetch(entry_bucket_name_api)
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            this.session.entry_image = data.body.URL;
            this.entry_image_fetching = false;
          })
          .catch((err) => {
            //console.log(err);
            this.session.entry_image = "";
          });
      } else {
        this.entry_image_fetching = false;
      }

      if (this.session_type == 2) {
        if (this.session.exit_image_name != "") {
          this.exit_image_fetching = true;

          let exit_bucket_name_api = "";
          if (this.session.exit_bucket_name == "NEW") {
            exit_bucket_name_api =
              window.awsURLNew + this.session.exit_image_name;
          } else if (this.session.exit_bucket_name == "OLD") {
            exit_bucket_name_api = window.awsURL + this.session.exit_image_name;
          } else {
            exit_bucket_name_api = window.awsURL + this.session.exit_image_name;
          }

          fetch(exit_bucket_name_api)
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              this.session.exit_image = data.body.URL;
              this.exit_image_fetching = false;
            })
            .catch((err) => {
              this.session.exit_image = "";
            });
        } else {
          this.exit_image_fetching = false;
        }
      }
    },
    /*  getEntryExitImages() {
      if (this.session.entry_image_name != "") {
        this.entry_image_fetching = true;

        //============= Check Old Bucket Image ================//
        // /$DEVICE_ID/${DATE}_${TIME}_${SESSION_ID}
        var session_id = "";
        var data = this.session.entry_image_name.split("_");
        if (data.length >= 4) {
          session_id = data[3];
        }
        //console.log(this.session.booking_id, session_id);
        if (this.session.booking_id == session_id) {
          fetch(window.awsURL + this.session.entry_image_name)
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              this.session.entry_image = data.body.URL;
              this.entry_image_fetching = false;
            })
            .catch((err) => {
              //console.log(err);
              this.getImageFromNewBucket();
              this.session.entry_image = "";
            });
        } else {
          this.getImageFromNewBucket();
        }
      } else {
        this.entry_image_fetching = false;
      }

      if (this.session_type == 2) {
        if (this.session.exit_image_name != "") {
          this.exit_image_fetching = true;
          //============= Check Old Bucket Image ================//
          // /$DEVICE_ID/${DATE}_${TIME}_${SESSION_ID}
          var exit_session_id = "";
          data = this.session.exit_image_name.split("_");
          if (data.length >= 4) {
            exit_session_id = data[3];
          }
          if (this.session.booking_id == exit_session_id) {
            fetch(window.awsURL + this.session.exit_image_name)
              .then((response) => {
                return response.json();
              })
              .then((data) => {
                this.session.exit_image = data.body.URL;
                this.exit_image_fetching = false;
              })
              .catch((err) => {
                this.getImageFromNewBucket();
                this.session.exit_image = "";
              });
          } else {
            this.getImageFromNewBucket();
          }
        } else {
          this.exit_image_fetching = false;
        }
      }
    }, */
    getImageFromNewBucket() {
      if (this.session.entry_image_name != "") {
        this.entry_image_fetching = true;
        if(this.session.entry_image_name[0]=='/')
        {
          this.session.entry_image_name = this.session.entry_image_name.substring(1);
        }
        
        fetch(window.awsURLNew + this.session.entry_image_name)
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            this.session.entry_image = data.body.URL;
            this.entry_image_fetching = false;
          })
          .catch((err) => {
            //console.log(err);
            this.session.entry_image = "";
            this.entry_image_fetching = false;
          });
      } else {
        this.entry_image_fetching = false;
      }
      if (this.session_type == 2) {
        if (this.session.exit_image_name != "") {
          this.exit_image_fetching = true;
          if(this.session.exit_image_name[0]=='/')
          {
            this.session.exit_image_name = this.session.exit_image_name.substring(1);
          } 
          
          fetch(window.awsURLNew + this.session.exit_image_name)
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              this.session.exit_image = data.body.URL;
              this.exit_image_fetching = false;
            })
            .catch((err) => {
              //console.log(err);
              this.session.exit_image = "";
              this.exit_image_fetching = false;
            });
        } else {
          this.exit_image_fetching = false;
        }
      }
    },
    showCustomer() {
      this.show_cust = !this.show_cust;
    },
    showEditVehicle() {
      this.edit_mode = true;
      this.country_list = [];
      this.state_list = [];
      this.vehicle_list = [];
      this.page = 1;
      this.load_more_vehicle = false;
      this.getCountries();
      this.getStates();
      // this.getUserVehicles();
      let vehicle_form = {
        license: this.session.vehicle_details && this.session.vehicle_details.license_id ? this.session.vehicle_details.license_id : "",
        vin: this.session.vehicle_details && this.session.vehicle_details.vin_id ? this.session.vehicle_details.vin_id : "",
        country_code: this.session.vehicle_details.country_code,
        state: this.session.vehicle_details.state,
        region_code: this.session.vehicle_details.region_code,
        make: this.session.vehicle_details && this.session.vehicle_details.make ? this.session.vehicle_details.make : "",
        model: this.session.vehicle_details && this.session.vehicle_details.model ? this.session.vehicle_details.model : "",
        year: this.session.vehicle_details && this.session.vehicle_details.model_year ? this.session.vehicle_details.model_year : "",
        fuel_type: this.session.vehicle_details && this.session.vehicle_details.fuel_type ? this.session.vehicle_details.fuel_type : "",
        color: this.session.vehicle_details && this.session.vehicle_details.color ? this.session.vehicle_details.color : "",
        property_id: this.property_id,
        vehicle_id: null,
      };

      this.vehicle_form = JSON.parse(JSON.stringify(vehicle_form));
    },
    cancelEditMode() {
      this.edit_mode = false;
      this.vehicle_form = {};
    },
    getCountries() {
      this.axios
        .post(window.hostname + "/api/auth/get-countries")
        .then((res) => {
          if (res.data.status) {
            this.country_list = res.data.data.country_list;
          } else {
            this.country_list = [];
          }
        })
        .catch((err) => {
          this.country_list = [];
        });
    },
    getStates() {
      this.axios
        .post(window.hostname + "/api/auth/get-states", {
          country_code: this.vehicle_form.country_code,
        })
        .then((res) => {
          if (res.data.status) {
            this.state_list = res.data.data.state_list;
          } else {
            this.state_list = [];
          }
        })
        .catch((err) => {
          this.state_list = [];
        });
    },
    getUserVehicles() {
      if (this.vehicle_source) {
        this.vehicle_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.vehicle_source = CancelToken.source();
      this.loading = true;
      this.axios
        .post(
          window.hostname + "/api/admin/vehicles",
          {
            device_type: 1,
            mode: "vehicle-list",
            page: this.page,
            time_zone: this.$moment.tz.guess(),
            user_id: this.session.user.id,
            search: this.vehicle_search,
            limit: 10,
          },
          {
            cancelToken: this.vehicle_source.token,
          }
        )
        .then((res) => {
          if (res.data.status) {
            let vehicle_list = res.data.data.vehicle_list;

            vehicle_list.map((val) => {
              this.vehicle_list.push(val);
            });

            this.page++;
            this.load_more_vehicle =
              res.data.data.pagination.load_more == 1 ? true : false;
          } else {
            this.vehicle_list = [];
            this.load_more_vehicle = false;
          }
          this.loading = false;
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            return;
          }
          this.vehicle_list = [];
          this.load_more_vehicle = false;
          this.loading = false;
        });
    },
    async startObserv() {
      if (this.load_more_vehicle) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    stopObserv() {
      this.observer.disconnect();
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;

        // this.getUserVehicles();
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
    searchVehicle(search) {
      this.vehicle_search = search;
      this.page = 1;
      this.vehicle_list = [];
      // this.getUserVehicles();
    },
    changeVehicle() {
      if (this.vehicle_form.vehicle_id == "") {
        if (this.vehicle_form.license.length == 0) {
          this.$toasted.show("Please provide a license!", {
            icon: "times-circle",
            className: "error-class",
          });
          return;
        }
        if (this.vehicle_form.license.length > 12) {
          this.$toasted.show(
            "License can not be more than 12 characters long!",
            {
              icon: "times-circle",
              className: "error-class",
            }
          );
          return;
        }
        if (this.vehicle_form.country_code.length == 0) {
          this.$toasted.show("Please provide a country!", {
            icon: "times-circle",
            className: "error-class",
          });
          return;
        }
        if (this.vehicle_form.state.length == 0) {
          this.$toasted.show("Please provide a state!", {
            icon: "times-circle",
            className: "error-class",
          });
          return;
        }
      }

      this.vehicle_form.session_id = this.session.booking_id;
      this.vehicle_form.region_code =
        this.vehicle_form.country_code == this.vehicle_form.state
          ? this.vehicle_form.country_code
          : this.vehicle_form.country_code + "-" + this.vehicle_form.state;

      this.buttonChngVehicle.disabled = true;
      this.buttonChngVehicle.loading = true;
      this.buttonChngVehicle.success = false;

      this.axios
        .post(
          window.hostname + "/api/auth/update-session-vehicle",
          this.vehicle_form
        )
        .then((res) => {
          if (res.data.status) {
            this.$toasted.show(res.data.message, {
              icon: "check-circle",
              className: "success-class",
            });
            let vehicle = res.data.vehicle;
            this.session.vehicle_details = vehicle;
            this.vehicle_form.license = "";
            this.vehicle_form.make = "";
            this.vehicle_form.model = "";
            this.vehicle_form.fuel_type = "";
            this.vehicle_form.color = "";
            this.vehicle_form.year = "";
            this.vehicle_form.vin = "";
            this.vehicle_form.vehicle_id = "";
            this.edit_mode = false;

            this.buttonChngVehicle.disabled = false;
            this.buttonChngVehicle.loading = false;
            this.buttonChngVehicle.success = true;

            this.$emit("audit_correct_list_refresh", {
                  correct_vehicle_details:vehicle,
                  session_id:this.session.booking_id,
                });
          } else {

            this.buttonChngVehicle.disabled = false;
            this.buttonChngVehicle.loading = false;
            this.buttonChngVehicle.success = false;

            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
            return;
          }
        })
        .catch((err) => {

          this.buttonChngVehicle.disabled = false;
          this.buttonChngVehicle.loading = false;
          this.buttonChngVehicle.success = false;

          this.$toasted.show(err.response.data.message, {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
    deleteSession(session_id) {
      console.log(this.session.booking_type);
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to delete this session?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "api/auth/delete-session", {
              booking_id: session_id,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.$emit("session_delete", {
                  session_id:session_id
                });
                this.$modal.hide("session-details");
              } else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
                return;
              }
            })
            .catch((err) => {
              this.$toasted.show(err.response.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            });
        }
      });
    },
    syncSessionDetails(session_id){
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to synchronise session details?",
        showCancelButton: true,
      }).then((res)=>{
        if(res.value){
          this.axios
            .post(window.hostname + "api/auth/booking", {
              mode: 'sync-details',
              device_type: 1,
              session_id: session_id,
            }).then((result)=>{
              if(result.data.status){
                this.$set(this.session, "receipt_url", result.data.data.receipt_url || "");
                this.$toasted.show(result.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });

                console.log(result.data.data.receipt_url);
              }
              else{
                this.$toasted.show(result.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });                     
              }
            })
        }
      })
    },
    refundSessionAmount(session_id) {
      const maxAmount = this.session?.price_breakdown?.payable_amount || 0;

      this.$swal({
        title: "Refund",
        text: `Confirm the amount to refund`,
        input: "number",
        inputAttributes: {
          min: 0.01,
          max: maxAmount,
          step: 0.01,
        },
        inputValue: maxAmount.toFixed(2),
        showCancelButton: true,
        confirmButtonText: "Refund",
        inputValidator: (value) => {
          const num = parseFloat(value);
          if (isNaN(num) || num <= 0) {
            return "Please enter a valid refund amount.";
          }
          if (num > maxAmount) {
            return `Cannot refund more than $${maxAmount.toFixed(2)}`;
          }
        },
      }).then((res) => {
        if (res.value) {
          const refundAmount = parseFloat(res.value);

          this.axios
            .post(window.hostname + "api/auth/booking", {
              mode: "refund-amount",
              device_type: 1,
              session_id: session_id,
              refund_amount: refundAmount,
            })
            .then((result) => {
              if (result.data.status) {
                this.$toasted.show(result.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.$modal.hide("session-details");
              } else {
                this.$toasted.show(result.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
              }
            });
        }
      });
    },
    modifyUserRating(rating) {
      let usrconfig = {
        rating: parseFloat(rating),
        isIndicatorActive: false,
        style: {
          fullStarColor: "#f5a623",
          emptyStarColor: "#737373",
          starWidth: 12,
          starHeight: 12
        }
      };
      // window.EventBus.$emit("rating_update",usrconfig);
      return usrconfig;
    },
  },
};
</script>
<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}
select option {
  background: #121212;
  border: none;
  margin: 40px;
}
.sessions_number_box_long {
  background-color: var(--primaryWhite);
  border-radius: 3px;
  padding: 6px 8px;
  cursor: pointer;
  color: black;
  cursor: default;
}
.star-rating {
  display: flex;
  align-items: center;
}
.star-rating .star-container {
  display: flex;
}
.star-rating .star-container:not(:last-child) {
  margin-right: 5px;
}
</style>